import React, { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateManagerAssistantSetting } from 'Shared/actions/user';
import isEqual from 'lodash/isEqual';

import { managerAssistantSettingType } from 'Shared/constants/constants';

import AssistantsManagerSettingsPanel from '../AssistantsManagerSettingsPanel/AssistantsManagerSettingsPanel';
import FeedbackRecognitionSettingsControl from '../FeedbackRecognitionSettingsControl/FeedbackRecognitionSettingsControl';

import './FeedbackPrompt.scss';

function FeedbackPrompt() {
  const dispatch = useDispatch();

  const managerAssistantSetting = useSelector(state => {
    const { managerAssistantSettings } = state;
    if (!managerAssistantSettings.length) return null;
    return managerAssistantSettings.find(({ type }) => type === managerAssistantSettingType.FeedbackPrompt);
  });

  const initValues = {
    recurrenceAmount: managerAssistantSetting?.recurrence?.intervalAmount,
    recurrenceInterval: managerAssistantSetting?.recurrence?.intervalUnit,
    maxTimeWithoutPromptAmount: managerAssistantSetting?.maxTimeWithoutPromptAmount,
    maxTimeWithoutPromptUnit: managerAssistantSetting?.maxTimeWithoutPromptUnit,
  };

  const [formValues, setFormValues] = useState(initValues);

  const handleActiveToggleChange = () => {
    dispatch(updateManagerAssistantSetting(managerAssistantSetting.id, { active: !managerAssistantSetting.active }));
  };

  const handleRecurrenceAmountChange = event =>
    setFormValues({ ...formValues, recurrenceAmount: parseInt(event.target.value || 1, 10) });

  const handleRecurrenceIntervalChange = option => setFormValues({ ...formValues, recurrenceInterval: option.value });

  const handleMaxTimeWithoutPromptAmountChange = event =>
    setFormValues({ ...formValues, maxTimeWithoutPromptAmount: parseInt(event.target.value || 1, 10) });

  const handleMaxTimeWithoutPromptUnitChange = option =>
    setFormValues({ ...formValues, maxTimeWithoutPromptUnit: option.value });

  const handleCancelClick = () => setFormValues(initValues);

  const handleSubmitClick = () => {
    const formValuesTransformed = {
      recurrence_attributes: {
        id: managerAssistantSetting.recurrence.id,
        interval_unit: formValues.recurrenceInterval,
        interval_amount: formValues.recurrenceAmount,
      },
      max_time_without_prompt_amount: formValues.maxTimeWithoutPromptAmount,
      max_time_without_prompt_unit: formValues.maxTimeWithoutPromptUnit,
    };
    dispatch(updateManagerAssistantSetting(managerAssistantSetting.id, formValuesTransformed));
  };

  if (!managerAssistantSetting) return null;

  return (
    <AssistantsManagerSettingsPanel
      index={1}
      title="Bi-directional Feedback Prompt"
      shortDescription="Prompts your teammates to exchange bi-directional feedback with you."
      isActive={managerAssistantSetting.active}
      onActiveChange={handleActiveToggleChange}
      onCancelClick={handleCancelClick}
      onSubmitClick={handleSubmitClick}
      formChanged={!isEqual(formValues, initValues)}
    >
      <FeedbackRecognitionSettingsControl
        formValues={formValues}
        onAmountValueChange={handleRecurrenceAmountChange}
        onIntervalValueChange={handleRecurrenceIntervalChange}
        onMaxTimeWithoutPromptAmountChange={handleMaxTimeWithoutPromptAmountChange}
        onMaxTimeWithoutPromptUnitChange={handleMaxTimeWithoutPromptUnitChange}
        promptName="feedback"
      />
    </AssistantsManagerSettingsPanel>
  );
}

export default memo(FeedbackPrompt);
